import React, { useState, lazy, Suspense } from "react"
import { Helmet } from "react-helmet"
const Hero = lazy(() => import("./sections/client/Hero"))
const FeaturesHighlight = lazy(() =>
  import("./sections/client/FeaturesHighlight")
)
const TalentSearchFeature = lazy(() =>
  import("./sections/client/TalentSearchFeature")
)
const PayrollManagementFeature = lazy(() =>
  import("./sections/client/PayrollManagementFeature")
)
const WorkPassManagementFeature = lazy(() =>
  import("./sections/client/WorkPassManagementFeature")
)
const Statistics = lazy(() => import("./sections/client/Statistics"))
const TalentSearchPricing = lazy(() =>
  import("./sections/client/TalentSearchPricing")
)
const WorkPassPricing = lazy(() => import("./sections/client/WorkPassPricing"))
const MobileNav = lazy(() => import("./MobileNav"))
const TalentSearchCustomPricing = lazy(() =>
  import("./sections/client/TalentSearchCustomPricing")
)
const PayrollManagementPricing = lazy(() =>
  import("./sections/client/PayrollManagementPricing")
)
import Loading from "../components/activity_indicators/Loading"
import styles from "./styles.module.scss"

const ClientPage = () => {
  const [toggleCustomTalentSearchPricing, setToggleCustomTalentSearchPricing] =
    useState(false)

  const renderLoader = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "60vh",
      }}
    >
      <Loading />
    </div>
  )

  return (
    <div className={styles.body}>
      <Helmet>
        <title>For Employer - Jobline</title>
      </Helmet>

      <Suspense fallback={renderLoader()}>
        <MobileNav />
        <Hero />
        <FeaturesHighlight />
        <TalentSearchFeature />
        <PayrollManagementFeature />
        <WorkPassManagementFeature />
        <Statistics />

        {toggleCustomTalentSearchPricing ? (
          <TalentSearchCustomPricing
            toggleCustom={toggleCustomTalentSearchPricing}
            setToggleCustom={setToggleCustomTalentSearchPricing}
          />
        ) : (
          <TalentSearchPricing
            toggleCustom={toggleCustomTalentSearchPricing}
            setToggleCustom={setToggleCustomTalentSearchPricing}
          />
        )}

        <PayrollManagementPricing />
        <WorkPassPricing />
      </Suspense>
    </div>
  )
}

export default ClientPage
